<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mb-4 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          routerLink="/marketing/mediaroomRegistry"
        >
          REGISTRY
        </a>
        <a class="btn btn-dark btn-sm btn-reg">SOCIAL </a>
      </div>
    </div> -->

    <div class="row mb-4 mt-2 text-center">
      <div class="col-12">
        <div class="platform-cards-container">
          <!-- Instagram -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'instagram' }"
            (click)="
              filters.platform =
                filters.platform === 'instagram' ? '' : 'instagram';
              applyFilters()
            "
          >
            <div class="platform-icon ig">
              <i class="fab fa-instagram"></i>
            </div>
            <span class="platform-name">Instagram</span>
          </div>

          <!-- Facebook -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'facebook' }"
            (click)="
              filters.platform =
                filters.platform === 'facebook' ? '' : 'facebook';
              applyFilters()
            "
          >
            <div class="platform-icon fb">
              <i class="fab fa-facebook-f"></i>
            </div>
            <span class="platform-name">Facebook</span>
          </div>

          <!-- YouTube -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'youtube' }"
            (click)="
              filters.platform =
                filters.platform === 'youtube' ? '' : 'youtube';
              applyFilters()
            "
          >
            <div class="platform-icon yt">
              <i class="fab fa-youtube"></i>
            </div>
            <span class="platform-name">YouTube</span>
          </div>

          <!-- TikTok -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'tiktok' }"
            (click)="
              filters.platform = filters.platform === 'tiktok' ? '' : 'tiktok';
              applyFilters()
            "
          >
            <div class="platform-icon tt">
              <i class="fab fa-tiktok"></i>
            </div>
            <span class="platform-name">TikTok</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/strategy"
            >STRATEGY
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/semantika"
            >SEMANTIKA
          </a>
          <!-- <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/performance"
            >PERFORMANCE
          </a> -->
          <a class="btn btn-dark btn-sm btn-new">NOTES </a>
          <a class="btn btn-dark btn-sm btn-reg">MEDIAROOM </a>
        </div>
      </div>
    </div>

    <div class="mroomsocial-container p-4" *ngIf="!loading">
      <div class="mb-4">
        <h2 class="mb-1 fw-bold text-dark">Social Media Management</h2>
      </div>

      <!-- ── TOP FILTERS ──────────────────────────────────────────────────── -->
      <div class="card shadow-sm border-0 mb-4 p-3" style="border-radius: 8px">
        <div class="row g-2">
          <div class="col-4 col-md-4">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >Status</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              [(ngModel)]="filters.status"
              (change)="applyFilters()"
            >
              <option value="">All</option>
              <option value="pending">Pending</option>
              <option value="ready">Ready</option>
              <option value="error">Error</option>
              <option value="posted">Posted</option>
            </select>
          </div>
          <div class="col-4 col-md-4">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >Purpose</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              [(ngModel)]="filters.purpose"
              (change)="applyFilters()"
            >
              <option value="">All</option>
              <option value="branding">Branding</option>
              <option value="authority_building">Authority Building</option>
              <option value="service_highlight">Service Highlight</option>
              <option value="market_awareness">Market Awareness</option>
            </select>
          </div>
          <div class="col-4 col-md-4">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >Vertical</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              [(ngModel)]="filters.vertical"
              (change)="applyFilters()"
            >
              <option value="">All</option>
              <option value="corporate">Corporate</option>
              <option value="logistics">Logistics</option>
              <option value="courier">Courier</option>
              <option value="expansion">Expansion</option>
            </select>
          </div>
        </div>
      </div>

      <!-- ── 1. REQUEST INTAKE ─────────────────────────────────────────────── -->
      <div
        class="card shadow-sm border-0 mb-4"
        style="border-radius: 8px; overflow: hidden"
      >
        <!-- Card Header -->
        <div class="intake-card-header px-1 pt-4 pb-3">
          <div class="d-flex align-items-center gap-3 mb-1">
            <div class="intake-header-icon">
              <i class="fas fa-inbox"></i>
            </div>
            <div>
              <h2 class="fw-bold mb-0"><strong>1. INTAKE</strong></h2>
              <!-- <p class="mb-0 intake-subtitle">Governed Initiative Intake</p> -->
            </div>
          </div>
        </div>

        <!-- Metadata row: Constituting Entity | Handoff Type -->
        <div class="intake-meta-row px-4 py-3 d-flex align-items-stretch">
          <div class="intake-meta-block">
            <span class="intake-meta-label">CONSTITUTING ENTITY</span>
            <span class="intake-meta-value">{{
              intakeMetadata.constitutingEntity
            }}</span>
          </div>
          <div class="intake-meta-divider"></div>
          <div class="intake-meta-block">
            <span class="intake-meta-label">HANDOFF TYPE</span>
            <span class="intake-meta-value intake-meta-value--light">{{
              intakeMetadata.handoffType
            }}</span>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive pb-3 pt-3">
          <table
            class="table table-borderless table-sm small align-middle mb-0 text-start"
          >
            <thead class="thead-light">
              <tr class="intake-thead-row">
                <th class="intake-th">Order ID</th>
                <th class="intake-th">Platform</th>
                <th class="intake-th">Surface</th>
                <th class="intake-th">Category</th>
                <th class="intake-th">Objective</th>
                <th class="intake-th">Semantika</th>
                <th class="intake-th">STATUS</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of requestIntakeData; let last = last"
                class="intake-row"
                [ngClass]="{ 'border-bottom-0': last }"
              >
                <!-- ORDER ID -->
                <td class="py-3">
                  <span *ngIf="item.order_id" class="intake-order-id">{{
                    item.order_id
                  }}</span>
                  <span *ngIf="!item.order_id" class="text-muted"
                    >Not Received</span
                  >
                </td>

                <!-- PLATFORM -->
                <td class="py-3">
                  <div class="d-flex align-items-center gap-2">
                    <span
                      class="platform-icon platform-icon--sm"
                      [ngClass]="getPlatformClass(item.platform)"
                    >
                      <i [class]="getPlatformIcon(item.platform)"></i>
                    </span>
                    <span class="text-dark pl-1">{{
                      item.platform | titlecase
                    }}</span>
                  </div>
                </td>

                <!-- SURFACE -->
                <td class="py-3 text-dark">{{ item.surface }}</td>

                <!-- CATEGORY -->
                <td class="py-3 text-dark">{{ item.category }}</td>

                <!-- OBJECTIVE -->
                <td class="py-3 text-dark">{{ item.objective }}</td>

                <!-- SEMANTIKA -->
                <td class="py-3">
                  <span
                    *ngIf="item.semantika_status"
                    class="intake-semantika-badge"
                    [ngClass]="getSemantikaClass(item.semantika_status)"
                  >
                    <i [class]="item.semantika_icon" class="me-1"></i>
                    {{ item.semantika_status }}
                  </span>
                  <span *ngIf="!item.semantika_status" class="text-muted"
                    >&mdash;</span
                  >
                </td>

                <!-- STATUS -->
                <td class="py-3">
                  <span
                    class="intake-status-badge"
                    [ngClass]="getIntakeStatusClass(item.intake_status)"
                  >
                    <span class="intake-status-dot"></span>
                    {{ item.intake_status }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="!requestIntakeData || requestIntakeData.length === 0">
                <td colspan="7" class="text-center text-muted py-3 small">
                  No intake orders found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- ── 2. PRODUCTION ─────────────────────────────────────────────────── -->
      <div
        class="card shadow-sm border-0 mb-4 prod-card border-radius-lg"
        style="border-radius: 8px; overflow: hidden; background-color: #fafbfd"
      >
        <!-- Card Header -->
        <!-- <div class="px-1 pt-4 pb-3 border-0 bg-transparent">
          <h2 class="fw-bold mb-1 prod-title"><strong>2. PRODUCTION</strong></h2>
          <p class="mb-0 prod-subtitle">{{ productionMetadata.subtitle }}</p>
        </div> -->
        <div class="intake-card-header px-1 pt-4 pb-3">
          <div class="d-flex align-items-center gap-3 mb-1">
            <div class="intake-header-icon">
              <i class="fas fa-cogs"></i>
            </div>
            <div>
              <h2 class="fw-bold mb-0"><strong>2. PRODUCTION</strong></h2>
              <!-- <p class="mb-0 intake-subtitle">Governed Initiative Intake</p> -->
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive pb-3 pt-2">
          <table
            class="table table-borderless table-sm small align-middle mb-0 text-start prod-table"
          >
            <thead class="thead-light">
              <tr class="prod-thead-row">
                <th class="prod-th prod-th-first">Order ID</th>
                <th class="prod-th">Platform</th>
                <th class="prod-th">Surface</th>
                <th class="prod-th">Script &amp; Image</th>
                <th class="prod-th">Video Production</th>
                <th class="prod-th prod-th-last">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of productionData; let last = last"
                class="prod-row"
                [ngClass]="{ 'border-bottom-0': last }"
              >
                <!-- ORDER ID -->
                <td class="py-3">
                  <span class="pl-1 prod-text-blue">{{ item.order_id }}</span>
                </td>

                <!-- PLATFORM -->
                <td class="py-3">
                  <div class="d-flex align-items-center gap-2">
                    <span
                      class="platform-icon platform-icon--sm m-0"
                      [ngClass]="getPlatformClass(item.platform)"
                    >
                      <i [class]="getPlatformIcon(item.platform)"></i>
                    </span>
                    <span class="prod-text-blue pl-1">{{
                      item.platform | titlecase
                    }}</span>
                  </div>
                </td>

                <!-- SURFACE -->
                <td class="py-3">
                  <span class="prod-text-blue">{{ item.surface }}</span>
                </td>

                <!-- SCRIPT & IMAGE -->
                <td class="py-3">
                  <span
                    *ngIf="item.script_image !== 'N/A'"
                    class="prod-badge"
                    [ngClass]="getProductionBadgeClass(item.script_image)"
                  >
                    <i
                      [class]="getProductionBadgeIcon(item.script_image)"
                      class="mr-1"
                    ></i>
                    {{ item.script_image }}
                  </span>
                  <span
                    *ngIf="item.script_image === 'N/A'"
                    class="prod-badge prod-badge-na fw-semibold"
                    >N/A</span
                  >
                </td>

                <!-- VIDEO PRODUCTION -->
                <td class="py-3">
                  <span
                    *ngIf="item.video_prod !== 'N/A'"
                    class="prod-badge"
                    [ngClass]="getProductionBadgeClass(item.video_prod)"
                  >
                    <i
                      [class]="getProductionBadgeIcon(item.video_prod)"
                      class="mr-1"
                    ></i>
                    {{ item.video_prod }}
                  </span>
                  <span
                    *ngIf="item.video_prod === 'N/A'"
                    class="prod-badge prod-badge-na fw-semibold"
                    >N/A</span
                  >
                </td>

                <!-- STATUS -->
                <td class="py-3">
                  <span
                    *ngIf="item.status !== 'N/A'"
                    class="prod-badge"
                    [ngClass]="getProductionBadgeClass(item.status)"
                  >
                    <i
                      *ngIf="getProductionBadgeIcon(item.status)"
                      [class]="getProductionBadgeIcon(item.status)"
                      class="mr-1"
                    ></i>
                    {{ item.status }}
                  </span>
                  <span
                    *ngIf="item.status === 'N/A'"
                    class="prod-badge prod-badge-na fw-semibold"
                    >N/A</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer Note -->
        <div class="px-1 pb-4">
          <div class="prod-footer-note d-flex align-items-center mt-2 pl-2">
            <i class="fas fa-info-circle mr-2 prod-info-icon"></i>
            <span class="prod-footer-text"
              ><strong>Note:</strong> {{ productionMetadata.footerNote }}</span
            >
          </div>
        </div>
      </div>

      <!-- ── 3. READY ──────────────────────────────────────────────────────── -->
      <div
        class="card shadow-sm border-0 mb-4"
        style="border-radius: 8px; overflow: hidden"
      >
        <!-- Card Header -->
        <div
          class="ready-card-header px-1 pt-4 pb-3 d-flex align-items-start justify-content-between"
        >
          <div class="d-flex align-items-center gap-3">
            <div class="ready-header-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div>
              <h2 class="fw-bold mb-0 ready-title">
                <strong>3. READY</strong>
              </h2>
              <!-- <p class="mb-0 ready-subtitle">{{ readyMetadata.subtitle }}</p> -->
            </div>
          </div>
          <button
            class="btn ready-schedule-btn btn-sm fw-semibold d-flex align-items-center gap-2"
            (click)="openScheduleModal()"
          >
            <i class="far fa-calendar-alt pr-1"></i>
            Posting Schedule
          </button>
        </div>

        <!-- Table -->
        <div class="table-responsive pb-3 pt-2">
          <table
            class="table table-borderless table-sm small align-middle mb-0 text-start"
          >
            <thead class="thead-light">
              <tr class="ready-thead-row">
                <th class="ready-th">Order ID</th>
                <th class="ready-th">Platform</th>
                <th class="ready-th">Surface</th>
                <th class="ready-th">AI Pass</th>
                <th class="ready-th">Posting Date &amp; Time</th>
                <th class="ready-th">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let piece of readyPiecesData; let last = last"
                class="ready-row"
                [ngClass]="{ 'border-bottom-0': last }"
              >
                <!-- ORDER ID with thumbnail -->
                <td class="py-3">
                  <div class="d-flex align-items-center gap-2">
                    <div class="ready-thumb">
                      <img
                        *ngIf="piece.thumbnail"
                        [src]="piece.thumbnail"
                        alt=""
                        class="w-100 h-100"
                        style="object-fit: cover"
                      />
                      <div
                        *ngIf="!piece.thumbnail"
                        class="ready-thumb-empty"
                      ></div>
                    </div>
                    <span class="pl-1 ready-order-id">{{
                      piece.order_id
                    }}</span>
                  </div>
                </td>

                <!-- PLATFORM -->
                <td class="py-3">
                  <div class="d-flex align-items-center gap-2">
                    <span
                      class="platform-icon platform-icon--sm"
                      [ngClass]="getPlatformClass(piece.platform)"
                    >
                      <i [class]="getPlatformIcon(piece.platform)"></i>
                    </span>
                    <span class="text-dark pl-1">{{
                      piece.platform | titlecase
                    }}</span>
                  </div>
                </td>

                <!-- SURFACE -->
                <td class="py-3 text-dark">{{ piece.surface }}</td>

                <!-- AI PASS -->
                <td class="py-3">
                  <span
                    class="ready-aipass-badge"
                    [ngClass]="getAiPassClass(piece.ai_pass)"
                  >
                    {{ piece.ai_pass }}
                  </span>
                </td>

                <!-- POSTING DATE & TIME -->
                <td class="py-3">
                  <span class="text-dark">{{ piece.posting_date }}</span>
                  <span class="ready-time-separator mx-1">•</span>
                  <span class="text-dark">{{ piece.posting_time }}</span>
                </td>

                <!-- STATUS -->
                <td class="py-3">
                  <span
                    class="ready-status-badge"
                    [ngClass]="getReadyStatusClass(piece.status)"
                  >
                    {{ piece.status }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="!readyPiecesData || readyPiecesData.length === 0">
                <td colspan="6" class="text-center text-muted py-3 small">
                  No ready pieces found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ── 4. ISSUES ─────────────────────────────────────────────────────── -->
      <!-- Title & Date Selector -->
      <div
        class="card shadow-sm border-0 mb-4 p-3"
        style="border-radius: 8px; background-color: #fafbfd"
      >
        <div
          class="d-flex justify-content-between align-items-center mb-3 mt-2 px-1"
        >
          <!-- <div>
            <h2 class="fw-bold mb-1 issues-title">
              <strong>4. ISSUES</strong>
            </h2>
            <p class="mb-0 text-muted issues-subtitle">
              {{ issuesMetadata.subtitle }}
            </p>
          </div> -->
          <div class="d-flex align-items-center gap-3">
            <div class="ready-header-icon">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div>
              <h2 class="fw-bold mb-0 ready-title">
                <strong>4. ISSUES</strong>
              </h2>
            </div>
          </div>
          <div>
            <button
              class="btn btn-outline-secondary btn-sm rounded-3 px-3 py-1 bg-white border-light d-flex align-items-center gap-2"
            >
              <i class="far fa-calendar-alt text-muted pr-1"></i>
              <span class="fw-medium text-dark">{{
                issuesMetadata.selectedDate
              }}</span>
              <i class="fas fa-chevron-down text-muted small ms-1"></i>
            </button>
          </div>
        </div>

        <!-- Stats Cards Row -->
        <div class="row g-3 mb-0 max-issues-row">
          <!-- Total Issues -->
          <div class="col py-1 pr-1">
            <div class="card h-100 border-0 shadow-sm issues-stat-card">
              <div
                class="card-body p-3 d-flex flex-column justify-content-between"
              >
                <div>
                  <div class="text-dark fw-bold mb-1 small pr-3">
                    Total Issues
                  </div>
                  <div class="fw-bold issues-stat-value">
                    {{ issuesStats.total.value }}
                  </div>
                </div>
                <div class="mt-3">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      [style.width]="issuesStats.total.percent + '%'"
                    ></div>
                  </div>
                  <div class="small fw-semibold mt-1 text-muted">
                    {{ issuesStats.total.percent }}%
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Reject -->
          <div class="col p-1">
            <div class="card h-100 border-0 shadow-sm issues-stat-card">
              <div
                class="card-body p-3 d-flex flex-column justify-content-between"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <div class="text-dark fw-bold mb-1 small pr-3">Reject</div>
                    <div class="fw-bold issues-stat-value text-danger">
                      {{ issuesStats.reject.value }}
                    </div>
                  </div>
                  <div class="issues-icon-badge bg-danger-light text-danger">
                    <i class="fas fa-times"></i>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar bg-danger"
                      role="progressbar"
                      [style.width]="issuesStats.reject.percent + '%'"
                    ></div>
                  </div>
                  <div class="small fw-semibold mt-1 text-muted">
                    {{ issuesStats.reject.percent | number: "1.1-1" }}%
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Held -->
          <div class="col p-1">
            <div class="card h-100 border-0 shadow-sm issues-stat-card">
              <div
                class="card-body p-3 d-flex flex-column justify-content-between"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <div class="text-dark fw-bold mb-1 small pr-3">Held</div>
                    <div class="fw-bold issues-stat-value issues-text-purple">
                      {{ issuesStats.held.value }}
                    </div>
                  </div>
                  <div
                    class="issues-icon-badge issues-bg-purple-light issues-text-purple"
                  >
                    <i class="fas fa-pause"></i>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar issues-bg-purple"
                      role="progressbar"
                      [style.width]="issuesStats.held.percent + '%'"
                    ></div>
                  </div>
                  <div class="small fw-semibold mt-1 text-muted">
                    {{ issuesStats.held.percent | number: "1.1-1" }}%
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Expired -->
          <div class="col p-1">
            <div class="card h-100 border-0 shadow-sm issues-stat-card">
              <div
                class="card-body p-3 d-flex flex-column justify-content-between"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <div class="text-dark fw-bold mb-1 small pr-3">Expired</div>
                    <div class="fw-bold issues-stat-value issues-text-orange">
                      {{ issuesStats.expired.value }}
                    </div>
                  </div>
                  <div
                    class="issues-icon-badge issues-bg-orange-light issues-text-orange"
                  >
                    <i class="far fa-clock"></i>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="progress" style="height: 4px">
                    <div
                      class="progress-bar issues-bg-orange"
                      role="progressbar"
                      [style.width]="issuesStats.expired.percent + '%'"
                    ></div>
                  </div>
                  <div class="small fw-semibold mt-1 text-muted">
                    {{ issuesStats.expired.percent | number: "1.1-1" }}%
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Most Affected -->
          <div class="col py-1 pl-1">
            <div class="card h-100 border-0 shadow-sm issues-stat-card">
              <div
                class="card-body p-3 d-flex flex-column justify-content-between"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <div class="text-primary fw-bold mb-1 small pr-3">
                      Most Affected
                    </div>
                    <div class="fw-bold issues-stat-value text-dark fs-5 mt-2">
                      {{ issuesStats.mostAffected.platform }}
                    </div>
                  </div>
                  <div
                    class="issues-icon-badge issues-bg-blue-light text-primary"
                  >
                    <i class="fas fa-chart-line"></i>
                  </div>
                </div>
                <div class="mt-3 mb-1">
                  <div class="small fw-semibold text-muted">
                    {{ issuesStats.mostAffected.count }} issues ({{
                      issuesStats.mostAffected.percent
                    }}%)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Filters Row -->
        <div
          class="card shadow-sm border-0 mb-2 mt-0 p-3"
          style="border-radius: 8px"
        >
          <div class="row g-2">
            <div class="col">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Issue Type</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option value="">All</option>
                <option value="expired">Expired</option>
                <option value="reject">Reject</option>
                <option value="held">Held</option>
              </select>
            </div>
            <div class="col">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Platform</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option value="">All</option>
                <option value="facebook">Facebook</option>
                <option value="instagram">Instagram</option>
                <option value="youtube">YouTube</option>
                <option value="tiktok">TikTok</option>
              </select>
            </div>
            <div class="col">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Surface</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option value="">All</option>
                <option value="feed">Feed</option>
                <option value="reel">Reel</option>
                <option value="story">Story</option>
                <option value="carousel">Carousel</option>
                <option value="short">Short</option>
                <option value="video">Video</option>
              </select>
            </div>
            <!-- Enter + Clear Filters buttons -->
            <div class="col d-flex gap-2 justify-content-end mt-1">
              <button
                class="btn btn-dark btn-sm fw-semibold issues-btn-enter px-4"
              >
                Enter <i class="fas fa-arrow-right ms-2"></i>
              </button>
              <button
                class="btn btn-outline-secondary btn-sm bg-white text-muted fw-semibold d-flex align-items-center gap-2"
              >
                <i class="fas fa-sync-alt"></i> Clear Filters
              </button>
            </div>
          </div>
        </div>

        <!-- Table Section -->
        <div>
          <div class="table-responsive pb-3 pt-2 px-1">
            <table
              class="table table-borderless table-sm small align-middle mb-0 text-start issues-table"
            >
              <thead class="thead-light">
                <tr class="issues-thead-row">
                  <th class="issues-th issues-th-first">
                    Order ID <i class="fas fa-sort text-muted ms-1"></i>
                  </th>
                  <th class="issues-th">
                    Platform <i class="fas fa-sort text-muted ms-1"></i>
                  </th>
                  <th class="issues-th">
                    Surface <i class="fas fa-sort text-muted ms-1"></i>
                  </th>
                  <th class="issues-th">
                    Issue Type <i class="fas fa-sort text-muted ms-1"></i>
                  </th>
                  <th class="issues-th issues-th-last">View</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let item of issuesData; let last = last"
                  class="issues-row"
                  [ngClass]="{ 'border-bottom-0': last }"
                >
                  <!-- ORDER ID -->
                  <td class="py-3">
                    <span class="text-dark">{{ item.order_id }}</span>
                  </td>

                  <!-- PLATFORM -->
                  <td class="py-3 text-start">
                    <div
                      class="d-flex align-items-center gap-2 justify-content-start"
                    >
                      <span
                        class="platform-icon platform-icon--sm m-0"
                        [ngClass]="getPlatformClass(item.platform)"
                      >
                        <i [class]="getPlatformIcon(item.platform)"></i>
                      </span>
                      <span class="text-dark pl-1">{{
                        item.platform | titlecase
                      }}</span>
                    </div>
                  </td>

                  <!-- SURFACE -->
                  <td class="py-3 text-start">
                    <span class="text-dark">{{ item.surface }}</span>
                  </td>

                  <!-- ISSUE TYPE -->
                  <td
                    class="py-3 text-start fw-semibold"
                    [ngClass]="getIssueTypeBadgeClass(item.issue)"
                  >
                    <i [class]="getIssueTypeIcon(item.issue)" class="mr-2"></i>
                    {{ item.issue }}
                  </td>

                  <!-- VIEW -->
                  <td class="py-3 text-start">
                    <button
                      class="btn btn-outline-primary btn-sm px-3 rounded-pill bg-white border-light-primary text-primary fw-medium issues-btn-view"
                      (click)="openIssueModal(item)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- ── 5. PAUSE ──────────────────────────────────────────────────────── -->
      <div
        class="card shadow-sm border-0 mb-4"
        style="border-radius: 8px; overflow: hidden"
      >
        <!-- Card Header -->
        <div class="card-body pb-2">
          <div
            class="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3 mt-1"
          >
            <div class="d-flex align-items-center gap-3">
              <div class="ready-header-icon">
                <i class="fas fa-shield-alt"></i>
              </div>
              <div>
                <h2 class="fw-bold mb-0 ready-title">
                  <strong>{{ pauseMetadata.title }}</strong>
                </h2>
                <!-- <p class="mb-0 text-muted issues-subtitle">{{ pauseMetadata.subtitle }}</p> -->
              </div>
            </div>
            <!-- Global Status Badge -->
            <div class="pause-global-status-box">
              <div class="pause-global-status-label">GLOBAL POSTING STATUS</div>
              <div class="d-flex align-items-center gap-2 mt-1">
                <span class="pause-global-dot"></span>
                <span class="fw-bold text-dark pause-global-status-value">{{
                  pauseMetadata.globalStatus
                }}</span>
              </div>
              <div class="pause-global-updated text-muted mt-1">
                {{ pauseMetadata.lastUpdated }}
              </div>
            </div>
          </div>

          <!-- Info Banner -->
          <div
            class="pause-info-banner d-flex align-items-start gap-3 mb-3 p-3"
          >
            <i class="fas fa-info-circle pause-info-icon mt-1"></i>
            <div>
              <div class="fw-semibold pause-info-text">
                Use PAUSE to pause or resume publishing by Platform or Surface.
              </div>
              <div class="pause-info-text text-muted mt-1">
                Affected Pieces appear as "Held" while the Pause remains in
                effect. Terminal Held outcomes are recorded in ISSUES.
              </div>
            </div>
          </div>

          <!-- Platform / Surface Table -->
          <div class="table-responsive">
            <table
              class="table table-borderless table-sm small align-middle mb-0 text-start pause-table"
            >
              <thead class="thead-light">
                <tr class="pause-thead-row">
                  <th class="pause-th" style="width: 22%">Platform</th>
                  <th class="pause-th">Surface</th>
                  <th class="pause-th">Status</th>
                  <th class="pause-th text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let p of pauseData">
                  <tr
                    *ngFor="let s of p.surfaces; let i = index"
                    class="pause-row"
                  >
                    <!-- Platform cell: only on first surface row -->
                    <td
                      class="py-3 pause-platform-cell"
                      *ngIf="i === 0"
                      [attr.rowspan]="p.surfaces.length"
                    >
                      <div class="d-flex align-items-center gap-3">
                        <span
                          class="platform-icon platform-icon--lg m-0 mr-1"
                          [ngClass]="getPlatformClass(p.platform)"
                        >
                          <i [class]="getPlatformIcon(p.platform)"></i>
                        </span>
                        <div>
                          <div class="fw-bold text-dark">
                            {{ p.platformLabel }}
                          </div>
                          <div class="text-muted" style="font-size: 0.75rem">
                            {{ p.surfaceCount }} Surface{{
                              p.surfaceCount > 1 ? "s" : ""
                            }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <!-- Surface -->
                    <td class="py-3">
                      <span class="text-dark fw-medium">{{ s.name }}</span>
                    </td>
                    <!-- Status -->
                    <td class="py-3">
                      <span
                        class="pause-status-badge"
                        [ngClass]="getPauseStatusClass(s.status)"
                      >
                        <i
                          [class]="getPauseStatusIcon(s.status)"
                          class="me-1 pr-1"
                        ></i>
                        {{ s.status }}
                      </span>
                    </td>
                    <!-- Action -->
                    <td class="py-3 text-end">
                      <div class="btn-group" *ngIf="s.status === 'Active'">
                        <button
                          class="btn btn-outline-secondary btn-sm fw-medium pause-action-btn"
                          (click)="openPauseModal(p.platformLabel, s.name)"
                        >
                          Pause
                        </button>
                        <!-- <button class="btn btn-outline-secondary btn-sm pause-action-chevron dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown"></button> -->
                      </div>
                      <button
                        *ngIf="s.status === 'Held'"
                        class="btn btn-outline-primary btn-sm fw-medium pause-action-btn"
                        (click)="resumeSurface(p.platformLabel, s.name)"
                      >
                        Resume
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <!-- Footer note -->
          <div
            class="row align-items-center mt-3 pt-2 border-top pause-footer-bar"
          >
            <!-- Columna izquierda -->
            <div class="col">
              <div class="d-flex align-items-center gap-2 pause-footer-note">
                <i class="far fa-lightbulb pause-footer-icon pr-1"></i>
                <span class="text-muted small">
                  Pausing a platform or surface affects all new and in-progress
                  publishing for that scope according to the selected behavior.
                </span>
              </div>
            </div>

            <!-- Columna derecha -->
            <div class="col-auto">
              <button
                class="btn btn-outline-secondary btn-sm fw-medium d-flex align-items-center gap-2 bg-white"
              >
                <i class="fas fa-history pr-1"></i>
                View History
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ── 6. ADS ──────────────────────────────────────────────────────── -->
      <div
        class="card shadow-sm border-0 mb-4"
        style="border-radius: 8px; overflow: hidden"
      >
        <div class="card-body">
          <!-- Header -->
          <div class="d-flex align-items-center gap-3 mb-4 mt-1">
            <div class="ready-header-icon">
              <i class="fas fa-bullhorn"></i>
            </div>
            <div>
              <h2 class="fw-bold mb-0 ready-title">
                <strong>{{ adsMetadata.title }}</strong>
              </h2>
              <!-- <p class="mb-0 text-muted issues-subtitle">{{ adsMetadata.subtitle }}</p> -->
            </div>
          </div>
          <!-- Table -->
          <div class="table-responsive">
            <table
              class="table table-borderless table-sm small align-middle mb-0 text-start ads-table"
            >
              <thead class="thead-light">
                <tr class="ads-thead-row">
                  <th class="ads-th" style="width: 35%">Platform</th>
                  <th class="ads-th">Surface</th>
                  <th class="ads-th text-center">Activate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of adsData" class="ads-row">
                  <!-- Platform -->
                  <td class="py-3">
                    <div class="d-flex align-items-center gap-3">
                      <span
                        class="platform-icon m-0"
                        [ngClass]="getPlatformClass(row.platform)"
                      >
                        <i [class]="getPlatformIcon(row.platform)"></i>
                      </span>
                      <span class="fw-medium text-dark pl-1">{{
                        row.platformLabel
                      }}</span>
                    </div>
                  </td>
                  <!-- Surface badge -->
                  <td class="py-3">
                    <span
                      class="ads-surface-badge"
                      [ngClass]="getSurfaceBadgeClass(row.surface)"
                    >
                      {{ row.surface }}
                    </span>
                  </td>
                  <!-- Toggle -->
                  <td class="py-3 text-center">
                    <label class="ads-toggle">
                      <input type="checkbox" [(ngModel)]="row.active" />
                      <span class="ads-toggle-slider"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ── PAUSE MODAL OVERLAY ─────────────────────────────────────────────────── -->
<div
  *ngIf="isPauseModalOpen"
  class="pause-modal-overlay d-flex align-items-center justify-content-center"
>
  <div class="pause-modal-dialog">
    <div
      class="pause-modal-header d-flex justify-content-between align-items-start"
    >
      <h3 class="pause-modal-title fw-bold mb-0">
        Pause {{ pauseModalPlatform }} {{ pauseModalSurface }}?
      </h3>
      <button
        class="btn btn-link text-muted p-0 text-decoration-none pause-modal-close"
        (click)="closePauseModal()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="pause-modal-body mt-3">
      <p class="pause-modal-desc text-dark mb-3 pb-3 border-bottom">
        You are about to pause publishing for this surface.<br />
        Select how you want this pause to take effect.
      </p>

      <div class="pause-behavior-section mb-4">
        <label class="form-label fw-bold text-dark mb-3">Pause behavior</label>

        <!-- Immediate Pause -->
        <div class="d-flex align-items-start gap-3 mb-3 custom-radio-wrapper">
          <input
            class="custom-radio-input mt-2 mr-1"
            style="flex-shrink: 0"
            type="radio"
            name="pauseBehavior"
            id="behaviorImmediate"
            value="immediate"
            [(ngModel)]="pauseBehavior"
          />
          <div class="d-flex gap-3 align-items-start w-100">
            <div class="behavior-icon-box bg-primary-light text-primary">
              <i class="fas fa-bolt"></i>
            </div>
            <div class="pl-1">
              <label
                class="form-check-label fw-bold text-dark d-block mb-1 pl-0"
                for="behaviorImmediate"
                >Immediate Pause</label
              >
              <div class="text-muted small">
                Apply the Hold immediately. In-progress atomic work may safely
                complete, but no next stage or publication may begin for this
                scope.
              </div>
            </div>
          </div>
        </div>

        <!-- Drain and Pause -->
        <div class="d-flex align-items-start gap-3 custom-radio-wrapper">
          <input
            class="custom-radio-input mt-2 mr-1"
            style="flex-shrink: 0"
            type="radio"
            name="pauseBehavior"
            id="behaviorDrain"
            value="drain"
            [(ngModel)]="pauseBehavior"
          />
          <div class="d-flex gap-3 align-items-start w-100">
            <div class="behavior-icon-box bg-purple-light text-purple">
              <i class="far fa-clock"></i>
            </div>
            <div class="pl-1">
              <label
                class="form-check-label fw-bold text-dark d-block mb-1 pl-0"
                for="behaviorDrain"
                >Drain and Pause</label
              >
              <div class="text-muted small">
                Allow in-progress pieces to complete the pipeline. Pause new
                pieces after the pipeline is drained.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reason Input -->
      <div class="mb-4 pt-2">
        <label class="form-label fw-bold text-dark mb-2"
          >Reason (optional)</label
        >
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm border py-2 pr-5 custom-reason-input"
            placeholder="Enter reason for pause..."
            [(ngModel)]="pauseReason"
            maxlength="120"
          />
          <div class="position-absolute text-muted small reason-char-count">
            {{ pauseReason.length }} / 120
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ── ISSUE DETAILS MODAL ─────────────────────────────────────────────────── -->
<div
  *ngIf="isIssueModalOpen && selectedIssueDetails"
  class="pause-modal-overlay d-flex align-items-center justify-content-center"
  style="z-index: 1060"
  (wheel)="$event.preventDefault()"
>
  <div
    class="pause-modal-dialog"
    style="max-width: 850px"
    (wheel)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-start mb-3">
      <div class="d-flex gap-3">
        <i class="fas fa-eye fs-4 text-dark mt-1 mr-2"></i>
        <div>
          <h3 class="fw-bold mb-0 text-dark" style="font-size: 1.3rem">
            Issue Details
          </h3>
          <p class="text-muted small mb-0 mt-1">
            View summary and AI conclusion for this incident.
          </p>
        </div>
      </div>
      <button
        class="btn btn-link text-dark p-0 text-decoration-none fs-5"
        (click)="closeIssueModal()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Meta Grid -->
    <div class="issue-meta-box d-flex flex-wrap mb-3 p-3">
      <!-- Col 1 -->
      <div class="meta-col pe-3 position-relative" style="width: 25%">
        <div class="d-flex gap-3">
          <span
            class="platform-icon m-0 mr-2 d-flex align-items-center justify-content-center"
            style="width: 40px; height: 40px; font-size: 30px"
            [ngClass]="getPlatformClass(selectedIssueDetails.platform)"
          >
            <i [class]="getPlatformIcon(selectedIssueDetails.platform)"></i>
          </span>
          <div>
            <div class="mb-3">
              <div class="meta-label">PLATFORM</div>
              <div class="d-flex align-items-center gap-2 mt-1">
                <span class="fw-bold text-dark" style="font-size: 0.9rem">{{
                  selectedIssueDetails.platformLabel
                }}</span>
              </div>
            </div>
            <div>
              <div class="meta-label">SURFACE</div>
              <div class="fw-bold text-dark mt-1" style="font-size: 0.9rem">
                {{ selectedIssueDetails.surface }}
              </div>
            </div>
          </div>
        </div>
        <div class="meta-divider"></div>
      </div>

      <!-- Col 2 -->
      <div class="meta-col px-3 position-relative" style="width: 25%">
        <div class="mb-3">
          <div class="meta-label">CATEGORY</div>
          <div class="fw-bold text-dark mt-1" style="font-size: 0.9rem">
            {{ selectedIssueDetails.category }}
          </div>
        </div>
        <div>
          <div class="meta-label">OBJECTIVE</div>
          <div class="fw-bold text-dark mt-1" style="font-size: 0.9rem">
            {{ selectedIssueDetails.objective }}
          </div>
        </div>
        <div class="meta-divider"></div>
      </div>

      <!-- Col 3 -->
      <div class="meta-col px-3 position-relative" style="width: 25%">
        <div class="mb-3">
          <div class="meta-label">ISSUE TYPE</div>
          <div class="mt-1">
            <span
              class="issue-badge badge-reject"
              *ngIf="selectedIssueDetails.issueType === 'Reject'"
              >Reject</span
            >
            <span
              class="issue-badge badge-held"
              *ngIf="selectedIssueDetails.issueType === 'Held'"
              >Held</span
            >
            <span
              class="issue-badge badge-expired"
              *ngIf="selectedIssueDetails.issueType === 'Expired'"
              >Expired</span
            >
          </div>
        </div>
        <div>
          <div class="meta-label">CONCURRENT CONDITION</div>
          <div class="mt-1">
            <span
              class="issue-badge badge-held"
              *ngIf="selectedIssueDetails.concurrentCondition === 'Held'"
              >Held</span
            >
          </div>
        </div>
        <div class="meta-divider"></div>
      </div>

      <!-- Col 4 -->
      <div class="meta-col pl-3" style="width: 25%">
        <div class="mb-3">
          <div class="meta-label">ORDER ID</div>
          <div class="fw-bold text-dark mt-1" style="font-size: 0.9rem">
            {{ selectedIssueDetails.orderId }}
          </div>
        </div>
        <div>
          <div class="meta-label">POSTING DATE & TIME</div>
          <div
            class="fw-bold text-dark mt-1"
            style="line-height: 1.4; font-size: 0.9rem"
          >
            {{ selectedIssueDetails.postingDate }}<br />
            {{ selectedIssueDetails.postingTime }}
          </div>
        </div>
      </div>
    </div>

    <!-- AI Conclusion Box -->
    <div class="issue-alert-box alert-red d-flex gap-3 mb-3 p-3">
      <div
        class="alert-icon-box bg-red-icon text-danger flex-shrink-0 mt-1 mr-2 d-flex align-items-center justify-content-center"
        style="width: 38px; height: 38px; border-radius: 50%"
      >
        <i class="fas fa-magic wd-icon"></i>
      </div>
      <div>
        <h6
          class="alert-title text-danger fw-bold mb-2"
          style="font-size: 0.8rem"
        >
          {{ selectedIssueDetails.conclusionTitle }}
        </h6>
        <p
          class="mb-1 text-dark"
          style="font-size: 0.9rem; line-height: 1.5"
          *ngFor="let line of selectedIssueDetails.conclusionDetails"
        >
          {{ line }}
        </p>
      </div>
    </div>

    <!-- Operational Summary Box -->
    <div class="issue-alert-box alert-blue d-flex gap-3 mb-3 p-3">
      <div
        class="alert-icon-box bg-blue-icon text-primary flex-shrink-0 mt-1 mr-2 d-flex align-items-center justify-content-center"
        style="width: 38px; height: 38px; border-radius: 50%"
      >
        <i class="fas fa-clipboard-list wd-icon"></i>
      </div>
      <div>
        <h6
          class="alert-title text-primary fw-bold mb-2"
          style="font-size: 0.8rem"
        >
          {{ selectedIssueDetails.summaryTitle }}
        </h6>
        <p
          class="mb-1 text-dark"
          style="font-size: 0.9rem; line-height: 1.5"
          *ngFor="let line of selectedIssueDetails.summaryDetails"
        >
          <span *ngIf="line !== ''">{{ line }}</span>
          <br *ngIf="line === ''" />
        </p>
      </div>
    </div>

    <!-- Footer -->
    <div
      class="d-flex justify-content-between align-items-center pt-3 mt-2"
      style="border-top: 1px solid #f0f2f5"
    >
      <button
        class="btn bg-white text-dark d-flex align-items-center gap-2 p-2 rounded-2 m-0"
        style="
          border: 1px solid #e2e8f0;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        "
      >
        <i
          class="fas fa-file-invoice text-primary pr-3"
          style="font-size: 1.25rem"
        ></i>
        <div class="text-start view-order" style="line-height: 1.1">
          <div class="text-primary fw-bold" style="font-size: 0.85rem">
            View Order
          </div>
          <div class="text-muted" style="font-size: 0.65rem">
            Open Order Details
          </div>
        </div>
      </button>
      <button
        class="btn btn-white fw-bold text-dark px-4 py-2 m-0"
        style="border: 1px solid #e2e8f0"
        (click)="closeIssueModal()"
      >
        Close
      </button>
    </div>
  </div>
</div>

<!-- ── POSTING SCHEDULE MODAL ─────────────────────────────────────────────── -->
<div
  *ngIf="isScheduleModalOpen"
  class="pause-modal-overlay d-flex align-items-center justify-content-center"
  style="z-index: 1070"
>
  <div class="pause-modal-dialog sched-modal-dialog">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-start mb-4">
      <div class="d-flex align-items-center gap-3">
        <span
          class="sched-header-check d-flex align-items-center justify-content-center mr-1"
        >
          <i class="fas fa-check"></i>
        </span>
        <div>
          <h3 class="fw-bold mb-0 text-dark" style="font-size: 1.3rem">
            3.2 POSTING SCHEDULE
          </h3>
          <p class="text-muted small mb-0 mt-1">
            Read-only view of recent posting history and upcoming scheduled
            slots.
          </p>
        </div>
      </div>
      <div class="d-flex align-items-center gap-2">
        <span class="sched-readonly-badge"
          ><i class="fas fa-lock mr-1"></i> Read-Only</span
        >
        <button
          class="btn btn-link text-dark p-0 text-decoration-none fs-5 ml-2"
          (click)="closeScheduleModal()"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Recent History Section -->
    <div class="sched-section mb-4">
      <div class="d-flex align-items-center gap-2 mb-1">
        <i class="far fa-clock text-primary pr-1"></i>
        <span class="fw-bold text-dark" style="font-size: 0.95rem"
          >Recent History — Last 4 Weeks</span
        >
      </div>
      <p class="text-muted small mb-3" style="font-size: 0.78rem">
        Completed weekly blocks only. The active READY block is not shown here.
      </p>
      <div class="table-responsive">
        <table
          class="table table-borderless table-sm small align-middle mb-0 sched-table"
        >
          <thead>
            <tr class="sched-thead-row">
              <th class="sched-th" style="width: 20%">Order ID</th>
              <th class="sched-th" style="width: 18%">Platform</th>
              <th class="sched-th" style="width: 12%">Surface</th>
              <th class="sched-th" style="width: 32%">
                Posting Date &amp; Time
              </th>
              <th class="sched-th text-end" style="width: 18%">
                Final Outcome
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="sched-row" *ngFor="let row of recentHistoryData">
              <td class="sched-order-id">{{ row.order_id }}</td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <span
                    class="platform-icon m-0 mr-1"
                    [ngClass]="getPlatformClass(row.platform)"
                  >
                    <i [class]="getPlatformIcon(row.platform)"></i>
                  </span>
                  <span class="fw-medium text-dark">{{
                    row.platformLabel
                  }}</span>
                </div>
              </td>
              <td class="text-muted">{{ row.surface }}</td>
              <td class="text-dark">
                <span class="fw-medium">{{ row.date }}</span>
                <span class="text-muted ml-2">{{ row.time }}</span>
              </td>
              <td class="text-end">
                <span
                  class="sched-outcome-badge"
                  [ngClass]="getOutcomeBadgeClass(row.outcome)"
                  >{{ row.outcome }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Upcoming Schedule Section -->
    <div class="sched-section mb-4">
      <div class="d-flex align-items-center gap-2 mb-1">
        <i class="far fa-calendar-alt text-primary pr-1"></i>
        <span class="fw-bold text-dark" style="font-size: 0.95rem"
          >Upcoming Schedule — Next 4 Weeks</span
        >
      </div>
      <p class="text-muted small mb-3" style="font-size: 0.78rem">
        Pre-assigned future posting slots generated from governed schedule
        rules.
      </p>
      <div class="table-responsive">
        <table
          class="table table-borderless table-sm small align-middle mb-0 sched-table"
        >
          <thead>
            <tr class="sched-thead-row">
              <th class="sched-th" style="width: 14%"></th>
              <th class="sched-th" style="width: 20%">Platform</th>
              <th class="sched-th" style="width: 13%">Surface</th>
              <th class="sched-th" style="width: 35%">
                Posting Date &amp; Time
              </th>
              <th class="sched-th text-end" style="width: 18%">Status</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let row of upcomingScheduleData; let i = index"
            >
              <tr class="sched-row">
                <!-- NEXT label — only rendered on the first row, spans all rows -->
                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="upcomingScheduleData.length"
                  class="sched-next-cell align-middle"
                >
                  <span class="sched-next-label">NEXT</span>
                </td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <span
                      class="platform-icon m-0 mr-1"
                      [ngClass]="getPlatformClass(row.platform)"
                    >
                      <i [class]="getPlatformIcon(row.platform)"></i>
                    </span>
                    <span class="fw-medium text-dark">{{
                      row.platformLabel
                    }}</span>
                  </div>
                </td>
                <td class="text-muted">{{ row.surface }}</td>
                <td class="text-dark">
                  <span class="fw-medium">{{ row.date }}</span>
                  <span class="text-muted ml-2">{{ row.time }}</span>
                </td>
                <td class="text-end">
                  <span class="sched-outcome-badge sched-badge-scheduled">{{
                    row.status
                  }}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Footer Note -->
    <div class="d-flex align-items-start gap-2 sched-footer-note p-3">
      <i class="fas fa-info-circle text-muted mt-1 flex-shrink-0"></i>
      <p class="mb-0 text-muted" style="font-size: 0.8rem">
        <strong>Note:</strong> Posting Schedule stores historical and future
        slot visibility only. Changes to schedule rules require approved
        governance and technical implementation.
      </p>
    </div>
  </div>
</div>
